/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
// this will be used to gauge the amount of time a user has spent for a given event fired by tracking
const s4 = () => Math.floor((1 + Math.random()) * 0x10000).toString(16).substring(1);
const generateId = () => s4() + s4() + '-' + s4() + '-' + s4() + '-' + s4() + '-' + s4() + s4() + s4();
export default generateId;